import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {NgbModal, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {CommonSvgIconsComponent} from "../../../shared/components/common-svg-icons/common-svg-icons.component";
import {TaskService} from "../../../core/services/task.service";
import {GeneralService} from "../../../core/services/general.service";
import {FeatherIconsComponent} from "../../../shared/components/feather-icons/feather-icons.component";
import {NewComponent} from "../new/new.component";
import {ConfirmComponent} from "../../../shared/components/generalModals/confirm/confirm.component";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {debounceTime} from "rxjs";
import {EventsEvidenceFilesComponent} from "../../service/event/events-evidence-files/events-evidence-files.component";

@Component({
  selector: 'app-list',
  standalone: true,
  imports: [CommonModule, NgbPaginationModule, CommonSvgIconsComponent, FeatherIconsComponent, ReactiveFormsModule],
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss'
})

export class ListComponent implements OnInit{
  @Input() selectedId: number;
  public openTab: string = "Abierto";
  searchControl = new FormControl('');

  tabData = [
    {
      value: "Abierto",
      icon: "check",
    },
    {
      value: "En proceso",
      icon: "activity",
    },
    {
      value: "Atrasados",
      icon: "clock",
    },
    {
      value: "Finalizado",
      icon: "check-circle",
    },
    {
      value: "Todos",
      icon: "list",
    },
  ];
  pageSize = 10;
  currentPage = 1;

  task: any[] = [];
  pagination: any = {};

  constructor(private taskService: TaskService, private generalService: GeneralService, public modal: NgbModal) {
  }

  ngOnInit() {
    this.getData();
    this.searchControl.valueChanges.pipe(
        debounceTime(500)  // espera 500 ms después del último cambio
    ).subscribe((value: any) => {
      this.onSearch(value);
    });
  }

  onSearch(value: string) {
    this.getData();
  }

  onPageChange(newPage: number) {
    this.currentPage = newPage;
    this.getData();
  }
  getInitials(name: string): string {
    if (!name) return '';
    const words = name.trim().split(/\s+/);
    let initials = words.map(w => w[0]).join('');
    return initials.substring(0, 2).toUpperCase();
  }
  getBadgeClass(status: string, type: number): string {
    let type1 = "";
    let type2 = "";
    switch (status) {
      case 'Abierto':
        type1 = "";
        type2 = "badge badge-light-primary";
        break;
      case 'En proceso':
        type1 = "circle-warning warning";
        type2 = "badge badge-light-warning";
        break;
      case 'Atrasados':
        type1 = "circle-danger danger";
        type2 = "badge badge-light-danger";
        break;
      case 'Finalizado':
        type1 = "circle-success success";
        type2 = "badge badge-light-success";
        break;
    }
    return (type == 1)?type1: type2;
  }

  // Función para obtener los fondeos del servicio
  getData() {
    let params: any = {
      'pageSize':this.pageSize,
      'filter': this.openTab,
      'page': this.currentPage,
      'filterLike': this.searchControl.value
    }
    this.taskService.getData(params).subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
          } else {
            this.task = res.message?.data;
            this.pagination = res.message?.pagination;
          }
        },
        (err: any) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
        }
    );
  }

  tabActive(value: string) {
    this.openTab = value;
    this.getData();

  }

  edit(item: any) {
    let modal = this.modal.open(NewComponent, { centered: true, size:'xl' });
    modal.componentInstance.data = item;
    modal.componentInstance.confirmAction = () => {
      this.openTab = 'Abierto';
      this.getData();
      modal.close();
    }
  }
  delete(item: any) {
    let modal = this.modal.open(ConfirmComponent, { centered: true });
    modal.componentInstance.image = "assets/images/gif/danger.gif";
    modal.componentInstance.title = "¿Estás seguro de que deseas eliminar este registro?";
    modal.componentInstance.description = "Esta acción no se puede deshacer. ¿Deseas continuar con la eliminación?";
    modal.componentInstance.refModel = modal;
    modal.componentInstance.confirmAction = () => {
      this.taskService.delete({id: item.id}).subscribe(
          (res: any) => {
            if (res.error) {
              this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            } else {
              this.generalService.showMessage('success', res.message);
              modal.close();
              this.getData();
            }
          },
          (err: any) => {
            this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          }
      );
    };
  }

  newTask(){
    let modal = this.modal.open(NewComponent, { centered: true, size:'xl' });
    modal.componentInstance.confirmAction = () => {
      this.openTab = 'Abierto';
      this.getData();
      modal.close();
    }
  }

  changeStatus(status: string, id: number){
    let modal = this.modal.open(ConfirmComponent, { centered: true });
    modal.componentInstance.image = "assets/images/gif/successful.gif";
    modal.componentInstance.title = "¿Confirmas el cambio de estatus de la tarea?";
    modal.componentInstance.description = 'La tarea pasará al estatus "'+status+'". ¿Deseas continuar?';
    modal.componentInstance.refModel = modal;
    modal.componentInstance.confirmAction = () => {
      this.taskService.changeStatus({status, id}).subscribe(
          (res: any) => {
            if (res.error) {
              this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            } else {
              modal.close();
              this.generalService.showMessage('success', res.message);
              this.openTab = status;
              this.getData();
            }
          },
          (err: any) => {
            this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          }
      );
    };
  }

  /**
   * Function: Abrir modal para visualizar los archivos de evidencia
   */
  getEvidenceFiles(row: any){
    if(row.evidence_urls && row.evidence_urls.split(',').length > 0) {
      let modal = this.modal.open(EventsEvidenceFilesComponent, { centered: true, size:'xl' });
      modal.componentInstance.list = row.evidence_urls;
      modal.componentInstance.close = () => {
        modal.close();
      }
    } else {
      this.generalService.showMessage('warn', 'No hay evidencias disponibles para mostrar.');
    }
  }

}
